module.exports = __webpack_public_path__ + "img/inlinelogo.fe2ff207.png";